import { IconSorting16 } from '@warp-ds/icons/react';
import { Button, Modal, Select } from '@warp-ds/react';
import { type ChangeEvent, useState } from 'react';
import type { Filters } from '@/domain';

type SortingProps = {
    filters: Filters;
    onFilterChanged: (filters: Filters) => void;
};

const sortingOptions = [
    { value: 'best', label: 'Mest relevant' },
    { value: 'published', label: 'Publisert' },
    { value: 'price_asc', label: 'Pris lav-høy' },
    { value: 'price_desc', label: 'Pris høy-lav' },
    { value: 'bedroom_asc', label: 'Soverom lav-høy' },
    { value: 'bedroom_desc', label: 'Soverom høy-lav' },
];

export const Sorting = ({ filters, onFilterChanged }: SortingProps) => {
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState(filters.sorting || 'best');

    const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSelected(event.target.value);
    };

    return (
        <>
            <Select
                className="hidden md:flex md:order-2"
                data-testid="ResultPage-sorting"
                id="sort"
                value={filters.sorting ? filters.sorting : 'best'}
                onChange={(event) => onFilterChanged({ sorting: event.target.value })}>
                {sortingOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </Select>
            <Button
                small
                utility
                className="md:hidden flex gap-4 min-w-8"
                onClick={() => {
                    setShowModal(!showModal);
                }}>
                <IconSorting16 aria-label="Sortering" />
                {sortingOptions.find((opt) => opt.value === selected)?.label}
            </Button>
            <Modal
                open={showModal}
                onDismiss={() => setShowModal(!showModal)}
                title={<span className="t3">Sortering</span>}
                footer={
                    <Button
                        primary
                        fullWidth
                        onClick={() => {
                            onFilterChanged({ sorting: selected });
                            setShowModal(false);
                        }}>
                        Bruk
                    </Button>
                }>
                {sortingOptions.map((opt) => (
                    <label key={opt.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="sorting"
                            className="m-8"
                            value={opt.value}
                            checked={selected === opt.value}
                            onChange={handleRadioChange}
                        />
                        {opt.label}
                    </label>
                ))}
            </Modal>
        </>
    );
};
